import React from 'react';
import LegalLayout from '../components/LegalLayout';

const SubscriptionTerms = () => (
  <LegalLayout title="Pro Subscription Terms" lastUpdated="August 8, 2026">
    <p>
      These Subscription Terms apply specifically to the Pro plan offered by Create by Lumera through Create by Lumera at <strong>createbylumera.com</strong>. These terms supplement our general <a href="/terms">Terms of Service</a>.
    </p>

    <h2>1. Pro Plan Overview</h2>
    <p>The Pro plan is a monthly subscription that provides:</p>
    <ul>
      <li>Unlimited AI-powered product generations</li>
      <li>Access to all 25+ product types and premium templates</li>
      <li>High-quality PNG export</li>
      <li>Print-ready PDF export (A4 and Letter sizes)</li>
      <li>Pinterest Pin Creator</li>
      <li>Shopify product export</li>
      <li>Priority support</li>
      <li>Commercial license for all generated content</li>
    </ul>

    <h2>2. Pricing</h2>
    <ul>
      <li><strong>USD:</strong> $19.99 per month (or $149 per year — save 38%)</li>
      <li><strong>NOK:</strong> 199 kr per month (or 1490 kr per year)</li>
    </ul>
    <p>
      Prices are shown inclusive of applicable taxes unless stated otherwise. We reserve the right to adjust pricing with 30 days' advance notice to existing subscribers.
    </p>

    <h2>3. Billing Cycle</h2>
    <ul>
      <li>Your subscription starts on the date of your first successful payment.</li>
      <li>Billing occurs <strong>monthly</strong> on the same calendar date as your initial purchase.</li>
      <li>Each billing cycle covers one month of Pro access from the billing date.</li>
    </ul>

    <h2>4. Automatic Renewal</h2>
    <p>
      <strong>Your Pro subscription renews automatically each month.</strong> This means your payment method will be charged on each renewal date until you cancel. You will not receive a separate notification before each charge — this notice serves as your ongoing disclosure.
    </p>
    <p>
      You can view your next billing date and manage auto-renewal from your <a href="/profile">Profile page</a>.
    </p>

    <h2>5. Payment Methods</h2>
    <p>We accept the following payment methods for Pro subscriptions:</p>
    <ul>
      <li><strong>Credit/Debit Cards</strong> (Visa, Mastercard, American Express) — processed via Stripe with recurring billing</li>
      <li><strong>PayPal</strong> — available as a one-time payment option (does not automatically renew)</li>
    </ul>
    <p>
      Note: PayPal payments activate Pro access but do not set up automatic monthly billing. If you pay via PayPal, your Pro access is granted as a one-time activation.
    </p>

    <h2>6. Cancellation</h2>
    <h3>6.1 How to Cancel</h3>
    <p>
      Cancel your subscription anytime from your <a href="/profile">Profile → Account tab</a>. No phone calls, emails, or waiting periods required.
    </p>

    <h3>6.2 Effect of Cancellation</h3>
    <ul>
      <li>Your next monthly charge is stopped immediately.</li>
      <li>You keep full Pro access until the end of your current paid period.</li>
      <li>After the period ends, your account automatically downgrades to the free plan.</li>
      <li>Your generated content and collections are preserved, but you lose access to Pro-only features.</li>
    </ul>

    <h3>6.3 Reactivation</h3>
    <p>
      You can reactivate at any time before your paid period ends. If you reactivate, your subscription resumes seamlessly — no double-charging or gap in service.
    </p>

    <h2>7. Failed Payments</h2>
    <p>If a renewal payment fails:</p>
    <ul>
      <li>Stripe will automatically retry the charge according to their smart retry schedule.</li>
      <li>If all retry attempts fail, your subscription will be cancelled and your account will be downgraded to the free plan.</li>
      <li>You can re-subscribe at any time from the <a href="/pricing">Pricing page</a>.</li>
    </ul>

    <h2>8. Promotional Codes</h2>
    <p>
      Promotional codes, when available, may reduce the price of your first billing cycle or provide a trial period. After the promotional period ends, regular pricing applies. Promotional codes cannot be combined and are subject to their individual terms.
    </p>

    <h2>9. Changes to Pro Plan</h2>
    <p>
      We may modify the features included in the Pro plan or adjust pricing. Existing subscribers will be notified at least 30 days before any price increase takes effect. You may cancel before the new pricing takes effect.
    </p>

    <h2>10. Contact</h2>
    <p>For subscription-related questions:</p>
    <ul>
      <li>Email: <strong>support@createbylumera.com</strong></li>
      <li>Self-service: <a href="/profile">Profile → Account tab</a></li>
    </ul>
  </LegalLayout>
);

export default SubscriptionTerms;
